import { Dealer } from '../models/dealer';

export const getServices = (dealers: Dealer[]) => {
  const services: string[] = [];
  // eslint-disable-next-line array-callback-return
  dealers.map((dealer) => {
    const dealerServices = dealer.services;
    dealerServices.map((dealerService) =>
      !services.includes(dealerService) ? services.push(dealerService) : dealerService,
    );
  });

  return services;
};
